module.exports = __webpack_public_path__ + "img/inactiveicon-network.d5a3f71b.svg";